import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { kebabCase } from 'lodash-es'

const Container = styled.section`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin: 40px 80px;

  @media screen and (max-width: 1200px) {
    margin: 20px 40px;
    gap: 16px;
  }
`

const Title = styled.h1`
  margin: 0;
  font-weight: 600;
  font-size: 36px;
  line-height: 40px;
  color: #101123;

  @media screen and (max-width: 1200px) {
    font-size: 28px;
    line-height: 36px;
  }
`

const Section = ({ title, children }) => (
  <Container id={kebabCase(title)}>
    <Title>{title}</Title>
    {children}
  </Container>
)

Section.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
}

export default Section
